export const provinceMap = [
  { citycode: '010', adcode: '110000', name: '北京市' },
  { citycode: '022', adcode: '120000', name: '天津市' },
  { citycode: '', adcode: '130000', name: '河北省' },
  { citycode: '', adcode: '140000', name: '山西省' },
  { citycode: '', adcode: '150000', name: '内蒙古自治区' },
  { citycode: '', adcode: '210000', name: '辽宁省' },
  { citycode: '', adcode: '220000', name: '吉林省' },
  { citycode: '', adcode: '230000', name: '黑龙江省' },
  { citycode: '021', adcode: '310000', name: '上海市' },
  { citycode: '', adcode: '320000', name: '江苏省' },
  { citycode: '', adcode: '330000', name: '浙江省' },
  { citycode: '', adcode: '340000', name: '安徽省' },
  { citycode: '', adcode: '350000', name: '福建省' },
  { citycode: '', adcode: '360000', name: '江西省' },
  { citycode: '', adcode: '370000', name: '山东省' },
  { citycode: '', adcode: '410000', name: '河南省' },
  { citycode: '', adcode: '420000', name: '湖北省' },
  { citycode: '', adcode: '430000', name: '湖南省' },
  { citycode: '', adcode: '440000', name: '广东省' },
  { citycode: '', adcode: '450000', name: '广西壮族自治区' },
  { citycode: '', adcode: '460000', name: '海南省' },
  { citycode: '023', adcode: '500000', name: '重庆市' },
  { citycode: '', adcode: '510000', name: '四川省' },
  { citycode: '', adcode: '520000', name: '贵州省' },
  { citycode: '', adcode: '530000', name: '云南省' },
  { citycode: '', adcode: '540000', name: '西藏自治区' },
  { citycode: '', adcode: '610000', name: '陕西省' },
  { citycode: '', adcode: '620000', name: '甘肃省' },
  { citycode: '', adcode: '630000', name: '青海省' },
  { citycode: '', adcode: '640000', name: '宁夏回族自治区' },
  { citycode: '', adcode: '650000', name: '新疆维吾尔自治区' },
  { citycode: '1886', adcode: '710000', name: '台湾省' },
  { citycode: '1852', adcode: '810000', name: '香港特别行政区' },
  { citycode: '1853', adcode: '820000', name: '澳门特别行政区' }
];

export const cityMap = [
  { name: '北京市', adcode: '110100', citycode: '' },
  { name: '天津市', adcode: '120100', citycode: '' },
  { name: '石家庄市', adcode: '130100', citycode: '' },
  { name: '唐山市', adcode: '130200', citycode: '' },
  { name: '秦皇岛市', adcode: '130300', citycode: '' },
  { name: '邯郸市', adcode: '130400', citycode: '' },
  { name: '邢台市', adcode: '130500', citycode: '' },
  { name: '保定市', adcode: '130600', citycode: '' },
  { name: '张家口市', adcode: '130700', citycode: '' },
  { name: '承德市', adcode: '130800', citycode: '' },
  { name: '沧州市', adcode: '130900', citycode: '' },
  { name: '廊坊市', adcode: '131000', citycode: '' },
  { name: '衡水市', adcode: '131100', citycode: '' },
  { name: '太原市', adcode: '140100', citycode: '' },
  { name: '大同市', adcode: '140200', citycode: '' },
  { name: '阳泉市', adcode: '140300', citycode: '' },
  { name: '长治市', adcode: '140400', citycode: '' },
  { name: '晋城市', adcode: '140500', citycode: '' },
  { name: '朔州市', adcode: '140600', citycode: '' },
  { name: '晋中市', adcode: '140700', citycode: '' },
  { name: '运城市', adcode: '140800', citycode: '' },
  { name: '忻州市', adcode: '140900', citycode: '' },
  { name: '临汾市', adcode: '141000', citycode: '' },
  { name: '吕梁市', adcode: '141100', citycode: '' },
  { name: '呼和浩特市', adcode: '150100', citycode: '' },
  { name: '包头市', adcode: '150200', citycode: '' },
  { name: '乌海市', adcode: '150300', citycode: '' },
  { name: '赤峰市', adcode: '150400', citycode: '' },
  { name: '通辽市', adcode: '150500', citycode: '' },
  { name: '鄂尔多斯市', adcode: '150600', citycode: '' },
  { name: '呼伦贝尔市', adcode: '150700', citycode: '' },
  { name: '巴彦淖尔市', adcode: '150800', citycode: '' },
  { name: '乌兰察布市', adcode: '150900', citycode: '' },
  { name: '兴安盟', adcode: '152200', citycode: '' },
  { name: '锡林郭勒盟', adcode: '152500', citycode: '' },
  { name: '阿拉善盟', adcode: '152900', citycode: '' },
  { name: '沈阳市', adcode: '210100', citycode: '' },
  { name: '大连市', adcode: '210200', citycode: '' },
  { name: '鞍山市', adcode: '210300', citycode: '' },
  { name: '抚顺市', adcode: '210400', citycode: '' },
  { name: '本溪市', adcode: '210500', citycode: '' },
  { name: '丹东市', adcode: '210600', citycode: '' },
  { name: '锦州市', adcode: '210700', citycode: '' },
  { name: '营口市', adcode: '210800', citycode: '' },
  { name: '阜新市', adcode: '210900', citycode: '' },
  { name: '辽阳市', adcode: '211000', citycode: '' },
  { name: '盘锦市', adcode: '211100', citycode: '' },
  { name: '铁岭市', adcode: '211200', citycode: '' },
  { name: '朝阳市', adcode: '211300', citycode: '' },
  { name: '葫芦岛市', adcode: '211400', citycode: '' },
  { name: '长春市', adcode: '220100', citycode: '' },
  { name: '吉林市', adcode: '220200', citycode: '' },
  { name: '四平市', adcode: '220300', citycode: '' },
  { name: '辽源市', adcode: '220400', citycode: '' },
  { name: '通化市', adcode: '220500', citycode: '' },
  { name: '白山市', adcode: '220600', citycode: '' },
  { name: '松原市', adcode: '220700', citycode: '' },
  { name: '白城市', adcode: '220800', citycode: '' },
  { name: '延边朝鲜族自治州', adcode: '222400', citycode: '' },
  { name: '哈尔滨市', adcode: '230100', citycode: '' },
  { name: '齐齐哈尔市', adcode: '230200', citycode: '' },
  { name: '鸡西市', adcode: '230300', citycode: '' },
  { name: '鹤岗市', adcode: '230400', citycode: '' },
  { name: '双鸭山市', adcode: '230500', citycode: '' },
  { name: '大庆市', adcode: '230600', citycode: '' },
  { name: '伊春市', adcode: '230700', citycode: '' },
  { name: '佳木斯市', adcode: '230800', citycode: '' },
  { name: '七台河市', adcode: '230900', citycode: '' },
  { name: '牡丹江市', adcode: '231000', citycode: '' },
  { name: '黑河市', adcode: '231100', citycode: '' },
  { name: '绥化市', adcode: '231200', citycode: '' },
  { name: '大兴安岭地区', adcode: '232700', citycode: '' },
  { name: '上海市', adcode: '310100', citycode: '' },
  { name: '南京市', adcode: '320100', citycode: '' },
  { name: '无锡市', adcode: '320200', citycode: '' },
  { name: '徐州市', adcode: '320300', citycode: '' },
  { name: '常州市', adcode: '320400', citycode: '' },
  { name: '苏州市', adcode: '320500', citycode: '' },
  { name: '南通市', adcode: '320600', citycode: '' },
  { name: '连云港市', adcode: '320700', citycode: '' },
  { name: '淮安市', adcode: '320800', citycode: '' },
  { name: '盐城市', adcode: '320900', citycode: '' },
  { name: '扬州市', adcode: '321000', citycode: '' },
  { name: '镇江市', adcode: '321100', citycode: '' },
  { name: '泰州市', adcode: '321200', citycode: '' },
  { name: '宿迁市', adcode: '321300', citycode: '' },
  { name: '杭州市', adcode: '330100', citycode: '' },
  { name: '宁波市', adcode: '330200', citycode: '' },
  { name: '温州市', adcode: '330300', citycode: '' },
  { name: '嘉兴市', adcode: '330400', citycode: '' },
  { name: '湖州市', adcode: '330500', citycode: '' },
  { name: '绍兴市', adcode: '330600', citycode: '' },
  { name: '金华市', adcode: '330700', citycode: '' },
  { name: '衢州市', adcode: '330800', citycode: '' },
  { name: '舟山市', adcode: '330900', citycode: '' },
  { name: '台州市', adcode: '331000', citycode: '' },
  { name: '丽水市', adcode: '331100', citycode: '' },
  { name: '合肥市', adcode: '340100', citycode: '' },
  { name: '芜湖市', adcode: '340200', citycode: '' },
  { name: '蚌埠市', adcode: '340300', citycode: '' },
  { name: '淮南市', adcode: '340400', citycode: '' },
  { name: '马鞍山市', adcode: '340500', citycode: '' },
  { name: '淮北市', adcode: '340600', citycode: '' },
  { name: '铜陵市', adcode: '340700', citycode: '' },
  { name: '安庆市', adcode: '340800', citycode: '' },
  { name: '黄山市', adcode: '341000', citycode: '' },
  { name: '滁州市', adcode: '341100', citycode: '' },
  { name: '阜阳市', adcode: '341200', citycode: '' },
  { name: '宿州市', adcode: '341300', citycode: '' },
  { name: '六安市', adcode: '341500', citycode: '' },
  { name: '亳州市', adcode: '341600', citycode: '' },
  { name: '池州市', adcode: '341700', citycode: '' },
  { name: '宣城市', adcode: '341800', citycode: '' },
  { name: '福州市', adcode: '350100', citycode: '' },
  { name: '厦门市', adcode: '350200', citycode: '' },
  { name: '莆田市', adcode: '350300', citycode: '' },
  { name: '三明市', adcode: '350400', citycode: '' },
  { name: '泉州市', adcode: '350500', citycode: '' },
  { name: '漳州市', adcode: '350600', citycode: '' },
  { name: '南平市', adcode: '350700', citycode: '' },
  { name: '龙岩市', adcode: '350800', citycode: '' },
  { name: '宁德市', adcode: '350900', citycode: '' },
  { name: '南昌市', adcode: '360100', citycode: '' },
  { name: '景德镇市', adcode: '360200', citycode: '' },
  { name: '萍乡市', adcode: '360300', citycode: '' },
  { name: '九江市', adcode: '360400', citycode: '' },
  { name: '新余市', adcode: '360500', citycode: '' },
  { name: '鹰潭市', adcode: '360600', citycode: '' },
  { name: '赣州市', adcode: '360700', citycode: '' },
  { name: '吉安市', adcode: '360800', citycode: '' },
  { name: '宜春市', adcode: '360900', citycode: '' },
  { name: '抚州市', adcode: '361000', citycode: '' },
  { name: '上饶市', adcode: '361100', citycode: '' },
  { name: '济南市', adcode: '370100', citycode: '' },
  { name: '青岛市', adcode: '370200', citycode: '' },
  { name: '淄博市', adcode: '370300', citycode: '' },
  { name: '枣庄市', adcode: '370400', citycode: '' },
  { name: '东营市', adcode: '370500', citycode: '' },
  { name: '烟台市', adcode: '370600', citycode: '' },
  { name: '潍坊市', adcode: '370700', citycode: '' },
  { name: '济宁市', adcode: '370800', citycode: '' },
  { name: '泰安市', adcode: '370900', citycode: '' },
  { name: '威海市', adcode: '371000', citycode: '' },
  { name: '日照市', adcode: '371100', citycode: '' },
  { name: '临沂市', adcode: '371300', citycode: '' },
  { name: '德州市', adcode: '371400', citycode: '' },
  { name: '聊城市', adcode: '371500', citycode: '' },
  { name: '滨州市', adcode: '371600', citycode: '' },
  { name: '菏泽市', adcode: '371700', citycode: '' },
  { name: '郑州市', adcode: '410100', citycode: '' },
  { name: '开封市', adcode: '410200', citycode: '' },
  { name: '洛阳市', adcode: '410300', citycode: '' },
  { name: '平顶山市', adcode: '410400', citycode: '' },
  { name: '安阳市', adcode: '410500', citycode: '' },
  { name: '鹤壁市', adcode: '410600', citycode: '' },
  { name: '新乡市', adcode: '410700', citycode: '' },
  { name: '焦作市', adcode: '410800', citycode: '' },
  { name: '濮阳市', adcode: '410900', citycode: '' },
  { name: '许昌市', adcode: '411000', citycode: '' },
  { name: '漯河市', adcode: '411100', citycode: '' },
  { name: '三门峡市', adcode: '411200', citycode: '' },
  { name: '南阳市', adcode: '411300', citycode: '' },
  { name: '商丘市', adcode: '411400', citycode: '' },
  { name: '信阳市', adcode: '411500', citycode: '' },
  { name: '周口市', adcode: '411600', citycode: '' },
  { name: '驻马店市', adcode: '411700', citycode: '' },
  { name: '济源市', adcode: '419001', citycode: '' },
  { name: '武汉市', adcode: '420100', citycode: '' },
  { name: '黄石市', adcode: '420200', citycode: '' },
  { name: '十堰市', adcode: '420300', citycode: '' },
  { name: '宜昌市', adcode: '420500', citycode: '' },
  { name: '襄阳市', adcode: '420600', citycode: '' },
  { name: '鄂州市', adcode: '420700', citycode: '' },
  { name: '荆门市', adcode: '420800', citycode: '' },
  { name: '孝感市', adcode: '420900', citycode: '' },
  { name: '荆州市', adcode: '421000', citycode: '' },
  { name: '黄冈市', adcode: '421100', citycode: '' },
  { name: '咸宁市', adcode: '421200', citycode: '' },
  { name: '随州市', adcode: '421300', citycode: '' },
  { name: '恩施土家族苗族自治州', adcode: '422800', citycode: '' },
  { name: '仙桃市', adcode: '429004', citycode: '' },
  { name: '潜江市', adcode: '429005', citycode: '' },
  { name: '天门市', adcode: '429006', citycode: '' },
  { name: '神农架林区', adcode: '429021', citycode: '' },
  { name: '长沙市', adcode: '430100', citycode: '' },
  { name: '株洲市', adcode: '430200', citycode: '' },
  { name: '湘潭市', adcode: '430300', citycode: '' },
  { name: '衡阳市', adcode: '430400', citycode: '' },
  { name: '邵阳市', adcode: '430500', citycode: '' },
  { name: '岳阳市', adcode: '430600', citycode: '' },
  { name: '常德市', adcode: '430700', citycode: '' },
  { name: '张家界市', adcode: '430800', citycode: '' },
  { name: '益阳市', adcode: '430900', citycode: '' },
  { name: '郴州市', adcode: '431000', citycode: '' },
  { name: '永州市', adcode: '431100', citycode: '' },
  { name: '怀化市', adcode: '431200', citycode: '' },
  { name: '娄底市', adcode: '431300', citycode: '' },
  { name: '湘西土家族苗族自治州', adcode: '433100', citycode: '' },
  { name: '广州市', adcode: '440100', citycode: '' },
  { name: '韶关市', adcode: '440200', citycode: '' },
  { name: '深圳市', adcode: '440300', citycode: '' },
  { name: '珠海市', adcode: '440400', citycode: '' },
  { name: '汕头市', adcode: '440500', citycode: '' },
  { name: '佛山市', adcode: '440600', citycode: '' },
  { name: '江门市', adcode: '440700', citycode: '' },
  { name: '湛江市', adcode: '440800', citycode: '' },
  { name: '茂名市', adcode: '440900', citycode: '' },
  { name: '肇庆市', adcode: '441200', citycode: '' },
  { name: '惠州市', adcode: '441300', citycode: '' },
  { name: '梅州市', adcode: '441400', citycode: '' },
  { name: '汕尾市', adcode: '441500', citycode: '' },
  { name: '河源市', adcode: '441600', citycode: '' },
  { name: '阳江市', adcode: '441700', citycode: '' },
  { name: '清远市', adcode: '441800', citycode: '' },
  { name: '东莞市', adcode: '441900', citycode: '' },
  { name: '中山市', adcode: '442000', citycode: '' },
  { name: '潮州市', adcode: '445100', citycode: '' },
  { name: '揭阳市', adcode: '445200', citycode: '' },
  { name: '云浮市', adcode: '445300', citycode: '' },
  { name: '南宁市', adcode: '450100', citycode: '' },
  { name: '柳州市', adcode: '450200', citycode: '' },
  { name: '桂林市', adcode: '450300', citycode: '' },
  { name: '梧州市', adcode: '450400', citycode: '' },
  { name: '北海市', adcode: '450500', citycode: '' },
  { name: '防城港市', adcode: '450600', citycode: '' },
  { name: '钦州市', adcode: '450700', citycode: '' },
  { name: '贵港市', adcode: '450800', citycode: '' },
  { name: '玉林市', adcode: '450900', citycode: '' },
  { name: '百色市', adcode: '451000', citycode: '' },
  { name: '贺州市', adcode: '451100', citycode: '' },
  { name: '河池市', adcode: '451200', citycode: '' },
  { name: '来宾市', adcode: '451300', citycode: '' },
  { name: '崇左市', adcode: '451400', citycode: '' },
  { name: '海口市', adcode: '460100', citycode: '' },
  { name: '三亚市', adcode: '460200', citycode: '' },
  { name: '三沙市', adcode: '460300', citycode: '' },
  { name: '儋州市', adcode: '460400', citycode: '' },
  { name: '五指山市', adcode: '469001', citycode: '' },
  { name: '沈抚改革创新示范区', adcode: '211500', citycode: '' },
  { name: '琼海市', adcode: '469002', citycode: '' },
  { name: '文昌市', adcode: '469005', citycode: '' },
  { name: '万宁市', adcode: '469006', citycode: '' },
  { name: '东方市', adcode: '469007', citycode: '' },
  { name: '定安县', adcode: '469021', citycode: '' },
  { name: '屯昌县', adcode: '469022', citycode: '' },
  { name: '澄迈县', adcode: '469023', citycode: '' },
  { name: '临高县', adcode: '469024', citycode: '' },
  { name: '白沙黎族自治县', adcode: '469025', citycode: '' },
  { name: '昌江黎族自治县', adcode: '469026', citycode: '' },
  { name: '乐东黎族自治县', adcode: '469027', citycode: '' },
  { name: '陵水黎族自治县', adcode: '469028', citycode: '' },
  { name: '保亭黎族苗族自治县', adcode: '469029', citycode: '' },
  { name: '琼中黎族苗族自治县', adcode: '469030', citycode: '' },
  { name: '重庆市', adcode: '500100', citycode: '' },
  { name: '成都市', adcode: '510100', citycode: '' },
  { name: '自贡市', adcode: '510300', citycode: '' },
  { name: '攀枝花市', adcode: '510400', citycode: '' },
  { name: '泸州市', adcode: '510500', citycode: '' },
  { name: '德阳市', adcode: '510600', citycode: '' },
  { name: '绵阳市', adcode: '510700', citycode: '' },
  { name: '广元市', adcode: '510800', citycode: '' },
  { name: '遂宁市', adcode: '510900', citycode: '' },
  { name: '内江市', adcode: '511000', citycode: '' },
  { name: '乐山市', adcode: '511100', citycode: '' },
  { name: '南充市', adcode: '511300', citycode: '' },
  { name: '眉山市', adcode: '511400', citycode: '' },
  { name: '宜宾市', adcode: '511500', citycode: '' },
  { name: '广安市', adcode: '511600', citycode: '' },
  { name: '达州市', adcode: '511700', citycode: '' },
  { name: '雅安市', adcode: '511800', citycode: '' },
  { name: '巴中市', adcode: '511900', citycode: '' },
  { name: '资阳市', adcode: '512000', citycode: '' },
  { name: '阿坝藏族羌族自治州', adcode: '513200', citycode: '' },
  { name: '甘孜藏族自治州', adcode: '513300', citycode: '' },
  { name: '凉山彝族自治州', adcode: '513400', citycode: '' },
  { name: '贵阳市', adcode: '520100', citycode: '' },
  { name: '六盘水市', adcode: '520200', citycode: '' },
  { name: '遵义市', adcode: '520300', citycode: '' },
  { name: '安顺市', adcode: '520400', citycode: '' },
  { name: '毕节市', adcode: '520500', citycode: '' },
  { name: '铜仁市', adcode: '520600', citycode: '' },
  { name: '贵安新区', adcode: '520900', citycode: '' },
  { name: '雄安新区', adcode: '133100', citycode: '' },
  { name: '黔西南布依族苗族自治州', adcode: '522300', citycode: '' },
  { name: '黔东南苗族侗族自治州', adcode: '522600', citycode: '' },
  { name: '黔南布依族苗族自治州', adcode: '522700', citycode: '' },
  { name: '昆明市', adcode: '530100', citycode: '' },
  { name: '曲靖市', adcode: '530300', citycode: '' },
  { name: '玉溪市', adcode: '530400', citycode: '' },
  { name: '保山市', adcode: '530500', citycode: '' },
  { name: '昭通市', adcode: '530600', citycode: '' },
  { name: '丽江市', adcode: '530700', citycode: '' },
  { name: '普洱市', adcode: '530800', citycode: '' },
  { name: '临沧市', adcode: '530900', citycode: '' },
  { name: '楚雄彝族自治州', adcode: '532300', citycode: '' },
  { name: '红河哈尼族彝族自治州', adcode: '532500', citycode: '' },
  { name: '文山壮族苗族自治州', adcode: '532600', citycode: '' },
  { name: '西双版纳傣族自治州', adcode: '532800', citycode: '' },
  { name: '大理白族自治州', adcode: '532900', citycode: '' },
  { name: '德宏傣族景颇族自治州', adcode: '533100', citycode: '' },
  { name: '怒江傈僳族自治州', adcode: '533300', citycode: '' },
  { name: '迪庆藏族自治州', adcode: '533400', citycode: '' },
  { name: '拉萨市', adcode: '540100', citycode: '' },
  { name: '日喀则市', adcode: '540200', citycode: '' },
  { name: '昌都市', adcode: '540300', citycode: '' },
  { name: '林芝市', adcode: '540400', citycode: '' },
  { name: '山南市', adcode: '540500', citycode: '' },
  { name: '那曲市', adcode: '540600', citycode: '' },
  { name: '阿里地区', adcode: '542500', citycode: '' },
  { name: '西安市', adcode: '610100', citycode: '' },
  { name: '铜川市', adcode: '610200', citycode: '' },
  { name: '宝鸡市', adcode: '610300', citycode: '' },
  { name: '咸阳市', adcode: '610400', citycode: '' },
  { name: '渭南市', adcode: '610500', citycode: '' },
  { name: '延安市', adcode: '610600', citycode: '' },
  { name: '汉中市', adcode: '610700', citycode: '' },
  { name: '榆林市', adcode: '610800', citycode: '' },
  { name: '安康市', adcode: '610900', citycode: '' },
  { name: '商洛市', adcode: '611000', citycode: '' },
  { name: '兰州市', adcode: '620100', citycode: '' },
  { name: '西咸新区', adcode: '611100', citycode: '' },
  { name: '嘉峪关市', adcode: '620200', citycode: '' },
  { name: '金昌市', adcode: '620300', citycode: '' },
  { name: '白银市', adcode: '620400', citycode: '' },
  { name: '天水市', adcode: '620500', citycode: '' },
  { name: '武威市', adcode: '620600', citycode: '' },
  { name: '张掖市', adcode: '620700', citycode: '' },
  { name: '平凉市', adcode: '620800', citycode: '' },
  { name: '酒泉市', adcode: '620900', citycode: '' },
  { name: '庆阳市', adcode: '621000', citycode: '' },
  { name: '定西市', adcode: '621100', citycode: '' },
  { name: '陇南市', adcode: '621200', citycode: '' },
  { name: '临夏回族自治州', adcode: '622900', citycode: '' },
  { name: '甘南藏族自治州', adcode: '623000', citycode: '' },
  { name: '西宁市', adcode: '630100', citycode: '' },
  { name: '海东市', adcode: '630200', citycode: '' },
  { name: '海北藏族自治州', adcode: '632200', citycode: '' },
  { name: '黄南藏族自治州', adcode: '632300', citycode: '' },
  { name: '海南藏族自治州', adcode: '632500', citycode: '' },
  { name: '果洛藏族自治州', adcode: '632600', citycode: '' },
  { name: '玉树藏族自治州', adcode: '632700', citycode: '' },
  { name: '海西蒙古族藏族自治州', adcode: '632800', citycode: '' },
  { name: '银川市', adcode: '640100', citycode: '' },
  { name: '石嘴山市', adcode: '640200', citycode: '' },
  { name: '吴忠市', adcode: '640300', citycode: '' },
  { name: '固原市', adcode: '640400', citycode: '' },
  { name: '中卫市', adcode: '640500', citycode: '' },
  { name: '乌鲁木齐市', adcode: '650100', citycode: '' },
  { name: '克拉玛依市', adcode: '650200', citycode: '' },
  { name: '吐鲁番市', adcode: '650400', citycode: '' },
  { name: '哈密市', adcode: '650500', citycode: '' },
  { name: '昌吉回族自治州', adcode: '652300', citycode: '' },
  { name: '博尔塔拉蒙古自治州', adcode: '652700', citycode: '' },
  { name: '巴音郭楞蒙古自治州', adcode: '652800', citycode: '' },
  { name: '阿克苏地区', adcode: '652900', citycode: '' },
  { name: '克孜勒苏柯尔克孜自治州', adcode: '653000', citycode: '' },
  { name: '喀什地区', adcode: '653100', citycode: '' },
  { name: '和田地区', adcode: '653200', citycode: '' },
  { name: '伊犁哈萨克自治州', adcode: '654000', citycode: '' },
  { name: '塔城地区', adcode: '654200', citycode: '' },
  { name: '阿勒泰地区', adcode: '654300', citycode: '' },
  { name: '石河子市', adcode: '659001', citycode: '' },
  { name: '阿拉尔市', adcode: '659002', citycode: '' },
  { name: '图木舒克市', adcode: '659003', citycode: '' },
  { name: '五家渠市', adcode: '659004', citycode: '' },
  { name: '北屯市', adcode: '659005', citycode: '' },
  { name: '铁门关市', adcode: '659006', citycode: '' },
  { name: '双河市', adcode: '659007', citycode: '' },
  { name: '可克达拉市', adcode: '659008', citycode: '' },
  { name: '昆玉市', adcode: '659009', citycode: '' },
  { name: '胡杨河市', adcode: '659010', citycode: '' },
  { name: '新星市', adcode: '659011', citycode: '' },
  { name: '白杨市', adcode: '659012', citycode: '' }
];



// WEBPACK FOOTER //
// ./src/common/gaodeMap.js